import { graphql } from 'gatsby'
import React from "react"
import { Helmet } from 'react-helmet'
import styles from "../styles/blog-post.module.css"
import { TwitterButton } from "react-social";
import Link from "gatsby-link"
import config from "../../data/config.js"
import Img from "gatsby-image"
import Layout from "../components/layout"


export default ({ data }) => {
  const post = data.markdownRemark
  const title = config.title + " | " + post.frontmatter.title
  const description = config.url  + post.fields.slug
  let previewImage = {}
  if(post.frontmatter.image != null && post.frontmatter.image.childImageSharp != null){
    previewImage = post.frontmatter.image.childImageSharp.fluid
  }

 const twitterTitle =  "'" + post.frontmatter.title + "' - "
  return (
    <Layout>
    <div>
    <Helmet>
      <title> {title} </title>
      <meta property="og:url" content={description} />
      <meta property="og:description" content={post.excerpt} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@fm_nestor" />
      <meta property="og:title" content={post.frontmatter.title} />
      <meta property="og:image" content={config.url + previewImage.src} />
      <meta name="twitter:text:title" content={post.frontmatter.title} />
      <meta name="twitter:description" content={post.excerpt} />
      <meta name="twitter:image" content={previewImage} />
    </Helmet>
    <h4>
    <span><Link to={`/authors/${post.frontmatter.author}`}> {post.frontmatter.author}</Link> on {post.frontmatter.date}</span>
    </h4>
      <h1>
        {post.frontmatter.title}
      </h1>


   <Img className={styles.HeaderImage} fluid={previewImage} />



      <div dangerouslySetInnerHTML={{ __html: post.html }} />
      <div className={styles.tweetBox}>Tweet this article: <TwitterButton element="i" url={description} message={twitterTitle} className="fa fa-twitter-square"></TwitterButton></div>



</div>
</Layout>

  )
}

export const query = graphql`
  query BlogPostQuery($slug: String! = "/blog/a-bold-move/") {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        date(formatString: "DD MMMM, YYYY")
	      categories
        author
        image {
          childImageSharp {
            fluid(duotone: {highlight: "#FFFFFF", shadow: "#e13327"}, maxWidth: 800) {
              ...GatsbyImageSharpFluid
            }
          }
          publicURL
        }
      }
      fields { slug }
      excerpt(pruneLength: 450)
    }

  }
`
